module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showPreferences) ? _c('marketing-preferences', {
    attrs: {
      "preferences": _vm.preferences
    },
    model: {
      value: (_vm.checked.preferences),
      callback: function($$v) {
        _vm.$set(_vm.checked, "preferences", $$v)
      },
      expression: "checked.preferences"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showDmn) ? _c('fieldset', [_c('input-checkbox', {
    attrs: {
      "label": _vm.dmnMsg
    },
    model: {
      value: (_vm.checked.dmnPermission),
      callback: function($$v) {
        _vm.$set(_vm.checked, "dmnPermission", $$v)
      },
      expression: "checked.dmnPermission"
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-796cd622","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketingCheckboxes.vue
// module id = 607
// module chunks = 0